import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';

import * as fromState from './wifi-profile.state';
import * as fromReducer from './wifi-profile.reducer';

import { AppleWifiProfilePreset } from '@rocksoft/mdm-sdk-v2';

export const selectWifiProfileState: Selector<object, fromState.WifiProfileState> =
  createFeatureSelector<fromState.WifiProfileState>('wifiProfiles');

export const selectWifiProfileIds: Selector<object, string[] | number[]> = createSelector(
  selectWifiProfileState,
  fromReducer.selectWifiProfileIds
);

export const selectWifiProfileEntities: Selector<object, Dictionary<AppleWifiProfilePreset>> = createSelector(
  selectWifiProfileState,
  fromReducer.selectWifiProfileEntities
);

export const selectAllWifiProfiles: Selector<object, AppleWifiProfilePreset[]> = createSelector(
  selectWifiProfileState,
  fromReducer.selectAllWifiProfiles
);

export const selectAllWifiProfilesLoaded: Selector<object, boolean> = createSelector(
  selectAllWifiProfiles,
  (settings) => settings && settings.length > 0
);
